// extracted by mini-css-extract-plugin
export var resizer = "_fz-0";